export default __webpack_public_path__ + "static/scw-5927f6b8eb1537d6932911dc7bcccc67.png";